export const QUESTION_STARTER = 'question-starter';

export type QuestionStarterOptions = {
  isReadOnly?: boolean;
  [key: string]: any;
};
